<!--

    Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<h1 class="heading-1 mb-4" data-test-id="user-list-headline">Benutzer & Rollen</h1>
<ods-routing-button
  [linkPath]="routes.BENUTZER_NEU"
  text="Benutzer hinzufügen"
  size="fit"
  dataTestId="add-user-button"
  spacing="medium"
/>
<odc-spinner [stateResource]="usersStateResource">
  <ods-list data-test-id="user-list">
    @for (user of usersStateResource.resource; track $index) {
      <li ods-list-item [path]="user.id" [attr.data-test-id]="(user.username | convertForDataTest) + '-user-entry'">
        <administration-user [user]="user" class="contents" />
      </li>
    }
  </ods-list>
</odc-spinner>
